import Swal from 'sweetalert2'

export async function toast(type: any, msg: string) {
  return Swal.fire({
    position: 'top-end',
    icon: type,
    showConfirmButton: false,
    timer: 5000,
    toast: true,
    title: msg,
    showCloseButton: true,
    grow: 'row',
    timerProgressBar: true,
  })
}
